import styled from 'styled-components';

import WarningModal from '~molecules/WarningModal';

export const WarrantyWarningModal = styled(WarningModal)(() => ({
  '& .modal-content': {
    width: '100%',
    maxWidth: '535rem',
  },
}));
